import { render, staticRenderFns } from "./ProfileIdentities.vue?vue&type=template&id=5c841a13&"
import script from "./ProfileIdentities.vue?vue&type=script&lang=js&"
export * from "./ProfileIdentities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports